$(".js-confirm_del").on('click',function (e) {
    if(!window.confirm($(this).data("confirm"))){
       e.preventDefault();
   }
});

$(".js-taenzerantwort_button").on('click',function (e) {
    e.preventDefault();
    $(".js-taenzerantwort_button ").show();
    $(this).hide();
    $(".js-taenzersuche_antwort_form").insertAfter($(this).parent());
    $(".js-taenzersuche_antwort_form").show();
    $(".js-taenzersuche_id").val($(this).data("id"))
    $(".js-taenzersuche_antwort_form").find(".js-email").trigger( "focus" );
});